// extracted by mini-css-extract-plugin
module.exports = {"container":"As-z","links":"Bs-z"};